// ID card logic

import {
  inferGenderFromOcrText,
  normalizeGender,
} from "../shared/normalizers";
import {
  normalizeFieldsFromSchema,
  resolveExtractedRawValue,
} from "../shared/fieldNormalization";
import { isSupportedUploadFile } from "../shared/uploadMime";

const CNIC_PATTERN = /^\d{5}-\d{7}-\d{1}$/;

const required = (value) =>
  value && String(value).trim() ? null : "This field is required.";

const cnicValidator = (value) => {
  if (!value || !String(value).trim()) return "This field is required.";
  return CNIC_PATTERN.test(String(value).trim())
    ? null
    : "CNIC must be in the format 12345-1234567-1.";
};

const schema = {
  type: "id_card",
  title: "ID Card (CNIC)",
  groups: [
    { id: "identity", label: "Identity" },
    { id: "numbers", label: "Numbers" },
    { id: "dates", label: "Dates" },
  ],
  fields: [
    {
      key: "name",
      label: "Name",
      group: "identity",
      inputType: "text",
      required: true,
      validate: required,
    },
    {
      key: "gender",
      label: "Gender",
      group: "identity",
      inputType: "select",
      options: ["Male", "Female", "Other"],
    },
    {
      key: "father_name",
      label: "Father Name",
      group: "identity",
      inputType: "text",
    },
    {
      key: "id_card_number",
      label: "CNIC Number",
      group: "numbers",
      inputType: "text",
      required: true,
      validate: cnicValidator,
    },
    {
      key: "date_of_birth",
      label: "Date of Birth",
      group: "dates",
      inputType: "date",
    },
    {
      key: "date_of_issue",
      label: "Issue Date",
      group: "dates",
      inputType: "date",
    },
    {
      key: "date_of_expiry",
      label: "Expiry Date",
      group: "dates",
      inputType: "date",
    },
  ],
};

const enrichExtractedJson = (extracted, rawText = "") => {
  const data = { ...(extracted || {}) };
  const text = String(rawText || "").trim();
  if (!text) return data;

  const current = resolveExtractedRawValue(data, "gender");
  const normalized = normalizeGender(current);
  if (!normalized) {
    const inferred = inferGenderFromOcrText(
      text,
      data.id_card_number || data.cnic_no || "",
    );
    if (inferred) data.gender = inferred;
  }

  return data;
};

const getLlmExtractionFields = () => schema.fields.map((field) => field.key);

const validateFieldValue = (key, value) => {
  const def = schema.fields.find((field) => field.key === key);
  if (!def || typeof def.validate !== "function") return null;
  return def.validate(value);
};

const normalizeExtractedJson = (extracted, rawText = "") => {
  const enriched = enrichExtractedJson(extracted, rawText);
  return normalizeFieldsFromSchema(schema, enriched, rawText);
};

const buildTableFromExtracted = () => null;

const appendTableToExtractedJson = (obj) => obj;

export const idCardType = {
  key: "id_card",
  schema,
  getLlmExtractionFields,
  enrichExtractedJson,
  normalizeExtractedJson,
  validateFieldValue,
  isSupportedFile: isSupportedUploadFile,
  buildTableFromExtracted,
  appendTableToExtractedJson,
};
